function getNoteByChapterKey(notes, chapterKey) {
  return notes.find(note => note.section === chapterKey.toString());
}

export default getNoteByChapterKey;



// WEBPACK FOOTER //
// ./src/utils/getNoteByChapterKey.js